import React from 'react';
import { useReveal } from '../hooks/useReveal';
import { cx } from '../utils/cx';
import mixins from '../styles/mixins.module.css';

// Bidirectional scroll-reveal wrapper shared by Home, AppDetailPage, and
// LegalPage — enters/exits from the correct edge depending on scroll
// direction, with an optional stagger delay.
export default function Reveal({ children, delay = 0, className }) {
  const [ref, state] = useReveal();
  return (
    <div
      ref={ref}
      className={cx(mixins.reveal, state.in && mixins.revealIn, className)}
      data-from={state.from}
      style={{ '--d': `${delay}ms` }}
    >
      {children}
    </div>
  );
}
